import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { SectionModel } from "../../../models/components.model";
import {
  Address,
  DocumentUrl,
  LoanRequestInfo,
} from "../../../models/cartable.model";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";

interface SchemaInfoModel {
  data?: LoanRequestInfo;
}
function _userInfo({ data }: SchemaInfoModel) {
  const sections: SectionModel[] = [
    // { dataKey: "mobileNumber", rowCol: 3, title: " تلفن همراه" },
    // { dataKey: "phoneNumber", rowCol: 3, title: "تلفن ثابت", },
    { dataKey: "customerFullName", rowCol: 4, title: " نام و نام خانوادگی" },
    { dataKey: "customerNationalCode", rowCol: 4, title: "کد ملی" },
    { dataKey: "birthDatePersian", rowCol: 4, title: " تاریخ تولد " },
    { dataKey: "customerMobileNumber", rowCol: 6, title: "تلفن همراه" },
    //{ dataKey: "customerMobileNumber", rowCol: 6, title: "شماره پرونده" },
  ];
  return (
    <DetailInfoComponentThumbnail
      sections={sections}
      data={data}
      documentList={undefined}
      height={"20vh"}
      addressByInquiry={false}
      showFooter={false}
    />
  );
}

export default function UserInfo({ data }: any) {
  const child = (
    <>
      <_userInfo data={data} />
    </>
  );

  return (
    <>
      <DivisionCmp child={child} title={"مشخصات کاربر"} />
    </>
  );
}
